/* eslint-disable no-unused-vars */
import React from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loaderActions } from '../../../../features/Loader/LoaderSlice';
import API from '../../../../Services/API';
import { toast } from 'react-hot-toast';
import Swal from 'sweetalert2';

function UserTable({ group, users, fetchUsers, setUserToEdit, openModal, verificationMethod }) {
  const dispatch = useDispatch();
  const isLoadingUsers = useSelector((state) => state.user.userLoading);
  const username = useSelector((state) => state.auth.username);

  function editUser(user) {
    setUserToEdit(user);
    openModal('edit');
  }

  function deleteUser(user) {
    Swal.fire({
      title: `Account Deletion`,
      text: `Do you want to delete this user!`,
      icon: `question`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, Delete it!`,
      customClass: {
        title: 'swal2-title-red'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        await dispatch(loaderActions.show());
        let res;
        try {
          res = await API().delete(`/evp-users/${user.email}`);
          toast.success('User deleted successfully', { id: 'delete' });
          await fetchUsers();
          await dispatch(loaderActions.hide());
        } catch (error) {
          toast.error(error.response.data, { id: 'delete' });
          await dispatch(loaderActions.hide());
        }
      }
    });
  }

  async function resendEmail(user) {
    await dispatch(loaderActions.show());
    const res = await API().post(`/evp-users/${user.email}/resend-code`);
    if (res.response && res.response.status >= 400) {
      toast.error(res.response.data.message || res.response.data.Message);
    } else {
      if (verificationMethod === 'CONFIRM_WITH_CODE') {
        toast.success('Verification OTP resent', { id: 'resend' });
      } else {
        toast.success('Confirmation email resent', { id: 'resend' });
      }
    }
    await dispatch(loaderActions.hide());
  }

  async function toggleEnable(user, status) {
    Swal.fire({
      title: `${status === 'enable' ? 'Reactive' : 'Deactivate'} confirmation`,
      text: `Do you want to ${status === 'enable' ? 'reactive' : 'deactivate'} this user!`,
      icon: `${status === 'enable' ? 'success' : 'warning'}`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${status === 'enable' ? 'reactive' : 'deactivate'} it!`,
      customClass: {
        title: 'swal2-title-red'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        await dispatch(loaderActions.show());
        const res = await API().post(`/evp-users/${user.email}/${status}`);
        if (res.response && res.response.status >= 400) {
          toast.error(res.response.data.message || res.response.data.Message);
        } else {
          toast.success(
            `User ${status === 'enable' ? 'reactivated' : 'deactivated'} successfully`,
            { id: 'activate' }
          );
        }
        await fetchUsers();
        await dispatch(loaderActions.hide());
      }
    });
  }

  const tableRows = users.map((user, i) => (
    <tr key={i} role={'button'}>
      <td>
        <div className="d-inline-block align-middle">
          <div className="d-inline-block">
            <h6 className="m-b-0">{i + 1}</h6>
          </div>
        </div>
      </td>
      <td>{user.email}</td>
      <td>
        {user.status === 'CONFIRMED' ? (
          <span className="badge text-white bg-success">Confirmed</span>
        ) : user.status === 'FORCE_CHANGE_PASSWORD' ? (
          <span className="badge text-white bg-warning">Password Change Requested</span>
        ) : (
          <span className="badge text-white bg-danger">Unconfirmed</span>
        )}
      </td>
      <td>
        {user && user.enabled === true ? (
          <span className="badge text-white  bg-success">Enabled</span>
        ) : (
          <span className="badge text-white  bg-danger">Disabled</span>
        )}
      </td>

      <td style={{ textAlign: 'right' }}>
        <div className="overlay-edit pr-5">
          {user.status !== 'CONFIRMED' && (
            <button
              type="button"
              className="btn text-white mr-2 btn-icon btn-success"
              onClick={() => resendEmail(user)}
            >
              Resend {verificationMethod === 'CONFIRM_WITH_CODE' ? 'OTP' : 'Email'}
            </button>
          )}
          {user && user.enabled === true ? (
            <button
              type="button"
              className="btn text-white mr-2 btn-icon btn-danger"
              onClick={() => toggleEnable(user, 'disable')}
            >
              Deactivate
            </button>
          ) : (
            <button
              type="button"
              className="btn text-white mr-2 btn-icon btn-success"
              onClick={() => toggleEnable(user, 'enable')}
            >
              Reactivate
            </button>
          )}
          {group.role !== 'all' && (
            <button type="button" className="btn btn-icon btn-info" onClick={() => editUser(user)}>
              <i className="feather icon-edit"></i>
            </button>
          )}
          {user.email !== `dynamics-support@emma-sleep.com` && user.email !== username && (
            <button
              type="button"
              className="btn text-white btn-icon btn-danger ml-2"
              onClick={() => deleteUser(user)}
            >
              <i className="feather icon-trash"></i>
            </button>
          )}
        </div>
      </td>
    </tr>
  ));

  return (
    <>
      <Row>
        <Col>
          <div className="card user-profile-list shadow-none">
            <div className="card-body shadow-none">
              <div className="dt-responsive table-responsive shadow-none">
                <table id={`${group.role}-list-table`} className="table nowrap shadow-none">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Email</th>
                      <th>Email Status</th>
                      <th>Account Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length > 0 ? (
                      tableRows
                    ) : !isLoadingUsers ? (
                      <tr>
                        <td colSpan={5}>
                          <Alert variant={'danger'}>
                            No user in <b>{group.title}</b> group found!
                          </Alert>
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default UserTable;
